
import React from "react"

export function NoWalletInstalled() {
    return (

        <div className="container"> 
            <p className=" fw-bolder text-center mt-5"> 沒有發現安裝任何電子錢包.
                建議可以先下載使用 {" "}
                <a
                    href="http://metamask.io"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    MetaMask
                </a>
            </p>

            <div className="row justify-content-center">
                <div className="card" style={{width:"18rem"}}>
                    <img className="card-img-top" src={require('../img/donate-banner-bigben.png')} alt="Card image cap" />
                    <div className="card-body">
                        <h5 className="card-title">Hello 我是大班哥</h5>
                        <p className="card-text">如果覺得我寫的文章不錯，歡迎支持我 0.01 ETH，讓我更有動力寫下去！</p>                        
                        <button className="btn btn-primary">打賞 0.01 ETH</button>
                    </div>
                </div>
            </div>
          


        </div>

        
    )
}